import GlobalContext from '../bootstrap';
import initMobileFilters from '../search/mobile-filters';
import initPropertySliders from '../property/sliders';
import initCharacterLimit from '../characterlimit';
import openSearchFilters from '../property/search-popup';
import initPagination from '../pagination';
import initTypeaheads from '../typeahead';
import itemDetailMaps from '../maps/item-map';
import onPopupOpenDirectory from '../events/popup-open-directory';
import resetableField from '../forms/resetable-field';

class DirectoryPage extends GlobalContext {
    constructor() {
        super();

        this._registerEvents();

        this._initialiseComponents();
    }

    _registerEvents() {
        window.addEventListener( 'twc:popup:open-directory', onPopupOpenDirectory );
    }

    _initialiseComponents(): void {
        const form = document.querySelector<HTMLFormElement>( '.search-area form' );

        if ( form ) {
            initMobileFilters( form );

            const autoTriggerSubmitSelects = form.querySelectorAll( '[name=radius],[name=languageSpoken]' );

            for ( let i = 0; i < autoTriggerSubmitSelects.length; i++ ) {
                autoTriggerSubmitSelects[ i ].addEventListener( 'change', function() {
                    form.submit();
                } );
            }
        }

        document.querySelectorAll<HTMLButtonElement>( 'button[data-action="open-search-filters"]' ).forEach( ( btn: HTMLButtonElement ) => {
            btn.addEventListener( 'click', () => {
                window.router.CaptureThen( openSearchFilters );
            } );

            btn.dataset.initialised = 'true';
        } );

        initTypeaheads();

        resetableField();

        initPropertySliders();

        initCharacterLimit();

        itemDetailMaps();

        if ( document.body.classList.contains( 'twc__pagination' ) ) {
            initPagination( document.body );
        }
    }
}

if ( !window.directoryPage ) {
    window.directoryPage = new DirectoryPage();
}
